// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { OTPConfig } from '../../Constants/appConstants';

//@component
function MerchantOTPDialog(props) {
  const OTP_TIME_LIMIT = OTPConfig.OTP_TIME_LIMIT;
  const OTP_LENGTH = OTPConfig.OTP_LENGTH;
  const [OTP, setOTP] = useState("");
  const [open] = useState(props.open);
  const [seconds, setSeconds] = useState(OTP_TIME_LIMIT);

  const isTimerActive = seconds > 0;

  useEffect(() => {
    if (!isTimerActive) {
      setOTP("");
      return;
    }
    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [isTimerActive]);

  const handleResend = () => {
    setSeconds(OTP_TIME_LIMIT);
    props.handleResend();
  };

  const handleOTPChange = (event) => {
    const numericValue = event.target.value
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);     
    setOTP(numericValue);
  };

  const handleVerify = () => {
    props.handleVerify(OTP);
  };

  const handleClose = () => {
    props.handleClose();
  }

  const  secToMinSec = (secondsInput) => {
  const totalSeconds = Math.floor(secondsInput);

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');

  return `${paddedMinutes}:${paddedSeconds}`;
}

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="download-dialog"
      maxWidth="xs"
      fullWidth
      length
      PaperProps={{
        style: {
          maxWidth: "350px",
        },
      }}
      //className="otp-dialog"
    >
      <DialogTitle>OTP Verification</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        className="otp-close-button"       
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        {/* <label>OTP*</label> */}
        <input
          placeholder="Please enter the OTP"
          className="otp-field"
          type="text"
          value={OTP}
          onChange={handleOTPChange}
          id="otp"
          autoComplete="off"
          inputProps={{
            maxLength: OTP_LENGTH,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          disabled={seconds === 0}
        />
        <Grid container className="label-container">
          <Grid size={6}>
            {seconds > 0 ? (
              <Typography
                variant="body2"
                color="text.secondary"
                className="resend-link"
              >
                Resend OTP in {secToMinSec(seconds)}
              </Typography>
            ) : (
              <Typography
                variant="body2"
                color="primary"
                className="resend-link-button"
                sx={{ cursor: "pointer" }}
                onClick={handleResend}
              >
                Resend OTP
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="verify-button"
          variant="contained"
          onClick={handleVerify}
          disabled={OTP.length !== OTP_LENGTH}
        >
          Verify & Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withRouter(
  connect(() => {
    return {};
  })(MerchantOTPDialog),
);
